import { makeStyles, Box, Button } from '@material-ui/core'
import React, {useState, useEffect} from 'react'
import ChangePasswordModal from './Modals/ChangePasswordModal'

const useStyles = makeStyles((theme) => ({
    root:{
        // width: '100%',
        border: `1px solid ${theme.palette.secondary.dark}`,
        borderRadius:'5px',
        marginTop:'30px',
        padding:'10px',
        [theme.breakpoints.down('md')]:{
            marginTop:'30px'
        }
    },
    tabHeading:{
        fontSize: '32px',
        fontWeight:550,
        margin:'0'
    },
    chngPassBtn:{
        color: 'white',
        backgroundColor: theme.palette.error.main,
        padding: '10px',
        minWidth: '200px',
        '&:hover':{
            backgroundColor: theme.palette.error.dark,
            boxShadow: '2px 2px 8px 4px rgba(0, 0, 0, 0.1)'
        }
    },
    line:{
        margin: '20px 0',
        color :'red',
        padding: '0'
    }
}))

function Settings(props) {
    const [passModal, setPassModal] = useState(false)
    const {user} = props
    const handleOpenModal = () => {
        setPassModal(true)
    }
    const handleCloseModal = () => {
        setPassModal(false)
    }
    useEffect(() => {
        // console.log({'Props in Settings': props})
    }, [])
    const classes = useStyles()
    return (
        <div className={classes.root}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <h2 className={classes.tabHeading}>Settings</h2>
            </Box>
            <p>Want to renew Password ? (Its Better to change frequently)</p>
            <Box display="flex" justifyContent="flex-end">
               <Button className={classes.chngPassBtn} onClick={handleOpenModal}>Change Password</Button>
            </Box>
            {/* <hr className={classes.line} />
            <Box display="flex" justifyContent="center">
                <Button className={classes.chngPassBtn}>Delete Your Account</Button>
            </Box> */}
            <ChangePasswordModal visible={passModal} closeModal={handleCloseModal} userId={user.author._id} />
        </div>
    )
}

export default Settings